import PubSub from "underpub-js";
import Slick from "slick-carousel";

var GalleryMatterportSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

GalleryMatterportSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$matterportSlider = this.options.$el.find('.matterport-slider')

	// initialize image slider
	this.$matterportSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		autoplay: false,
	});

	this.options.$el.find('.slider-navigation .slider-navigation-button').on('click', function() {

		var slideIndex = $(this).data('slideIndex') - 1;

		self.$matterportSlider.slick('slickGoTo', slideIndex);

		self.options.$el.find('.slider-navigation .slider-navigation-button').removeClass('active');

		$(this).addClass('active');

	});

};

export default GalleryMatterportSlider;
